import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import styles from './menuItem.module.scss'

class MenuItem extends Component {
    static propTypes = {
        children: PropTypes.string.isRequired,
        endIcon: PropTypes.object,
        id: PropTypes.string.isRequired,
        onClick: PropTypes.func,
        startIcon: PropTypes.object.isRequired,
        to: PropTypes.string,
    }

    static defaultProps = {
        withLevel: false,
    }

    /**
     * Handle menu item click
     */
    handleMenuItemClick = () => {
        const { id, onClick } = this.props

        onClick(id)
    }

    render() {
        const { children, endIcon, startIcon, to, href, ...rest } = this.props

        let LinkComponent = props => (
            <button onClick={this.handleMenuItemClick} {...props} />
        )

        if (to) {
            LinkComponent = props => (
                <Link onClick={this.handleMenuItemClick} to={to} {...props} />
            )
        }
        if (href) {
            LinkComponent = props => {
                // Merge extra props defined on menuitem with existing ones.
                const mergedProps = { ...rest, ...props }
                delete mergedProps.withLevel

                return (
                    <a href={href} {...mergedProps}>
                        {props.children}
                    </a>
                )
            }
        }

        return (
            <LinkComponent className={styles.menuItem}>
                <div className={styles.startIcon}>
                    <FontAwesomeIcon icon={startIcon} />
                </div>
                <span className={styles.menuItemText}>{children}</span>
                {endIcon ? (
                    <div className={styles.endIcon}>
                        <FontAwesomeIcon icon={endIcon} />
                    </div>
                ) : null}
            </LinkComponent>
        )
    }
}

export default MenuItem
